import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { ClinicContentBlockType } from '../../../data/models/ClinicContentBlockType';

@Component({
  selector: 'app-add-block-type-dialog',
  imports: [MatButtonModule, MatDialogModule, MatIconModule, MatListModule],
  templateUrl: './add-block-type-dialog.component.html',
  styleUrl: './add-block-type-dialog.component.scss'
})
export class AddBlockTypeDialogComponent {
  contentTypes: ClinicContentBlockType[]

  constructor(
    private dialogRef: MatDialogRef<AddBlockTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { blockTypes: ClinicContentBlockType[] }
  ) {
    this.contentTypes = data.blockTypes.filter(t => !t.is_standard)
  }

  getIcon(typeName: string): string {
    switch (typeName) {
      case 'text': return 'description'
      case 'video': return 'videocam'
      case 'image': return 'image'
      case 'button': return 'smart_button'
      case 'contact_person': return 'person'
      default: return 'add'
    }
  }

  getLabel(typeName: string): string {
    switch (typeName) {
      case 'text': return 'Textblock'
      case 'video': return 'Videoblock'
      case 'image': return 'Bildblock'
      case 'button': return 'Button'
      case 'contact_person': return 'Ansprechperson'
      default: return typeName
    }
  }

  selectType(type: ClinicContentBlockType): void {
    this.dialogRef.close(type)
  }
}
